// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__39F_A","info":"Note_info__2GfeU","note":"Note_note__1xLWe","actions":"Note_actions__2UZKp"};